import MobileTabsHeader from 'components/TabsHeader/MobileTabsHeader';
import TabsHeader from 'components/TabsHeader/TabsHeader';
import WidgetTimeUpdate from 'components/Widgets/WidgetTimeUpdate';
import { usePerms } from 'contexts/PermsContext';
import ForecastCharts from 'features/Weather/features/Forecast/features/ForecastCharts/index.web';
import { forecastChartConfig } from 'features/Weather/features/Forecast/features/ForecastCharts/config/forecastCharts.config';
import { useEffect } from 'react';
import { Container } from 'react-bootstrap';
import { useNavigate, useSearchParams } from 'react-router-dom';

const topTabs = forecastChartConfig.map(({ optionLabel }) => ({ option: optionLabel }));

/** Owns the Charts route, URL tabs, permission check, and page layout. */
export default function Charts() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const perms = usePerms();
  const selectedTab = params.get('tab')?.toLowerCase();
  const selectedChartId = forecastChartConfig.find(
    ({ optionLabel }) => optionLabel.toLowerCase() === selectedTab,
  )?.id;

  useEffect(() => {
    let isMounted = true;

    (async () => {
      if (!(await perms.validatePermissions(['ChartsEnabled'])) && isMounted) {
        navigate('/404');
      }
    })();

    return () => {
      isMounted = false;
    };
  }, [navigate, perms]);

  return (
    <Container fluid className="d-flex flex-column h-100 min-h-0 py-3">
      <div className="d-none d-lg-block flex-shrink-0">
        <TabsHeader options={topTabs} />
      </div>
      <div className="d-block d-lg-none flex-shrink-0">
        <MobileTabsHeader options={topTabs} />
      </div>
      <div className="d-flex flex-column flex-grow-1 min-h-0">
        <div className="flex-shrink-0">
          <WidgetTimeUpdate route="Charts" addMargin />
        </div>
        <div className="flex-grow-1 min-h-0">
          <ForecastCharts chartId={selectedChartId} />
        </div>
      </div>
    </Container>
  );
}
